"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formNewLaneEventPayload = formNewLaneEventPayload;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _clickStreamEventSchema = require("./clickStreamEventSchema");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formNewLaneEventPayload(eventType, newLaneEventData, additionalClickStreamData, isSecondary) {
  if (isSecondary === void 0) {
    isSecondary = false;
  }

  var _CLICKSTREAM_SCHEMA_D = (0, _clickStreamEventSchema.CLICKSTREAM_SCHEMA_DATA)(newLaneEventData.triggerLocation, newLaneEventData.triggerObject, newLaneEventData.triggerSource, isSecondary)[eventType],
      envelopeBlock = _CLICKSTREAM_SCHEMA_D.envelopeBlock,
      triggerBlock = _CLICKSTREAM_SCHEMA_D.triggerBlock,
      semanticBlock = _CLICKSTREAM_SCHEMA_D.semanticBlock;
  var properties = Object.assign({
    envelope: Object.assign({
      event_client_start_dtm: new Date().toISOString()
    }, envelopeBlock),
    clickstream_trigger: Object.assign(Object.assign({}, triggerBlock), {}, {
      // TODO: MTT-2939 update input_selector as we start tracking emitter info
      // (like mouse, keyboard, touch)
      input_selector_nm: 'other'
    }),
    semantic: Object.assign({}, semanticBlock),
    omp: Object.assign({
      event_type_nm: eventType
    }, (0, _omit.default)(newLaneEventData, 'triggerLocation', 'triggerObject', 'triggerSource', 'exposureData', 'isNbaProcessed', 'position', 'nbaContext'))
  }, additionalClickStreamData);
  return properties;
}